import { render, staticRenderFns } from "./InfoBallon.vue?vue&type=template&id=90fb0696"
import script from "./InfoBallon.vue?vue&type=script&lang=js"
export * from "./InfoBallon.vue?vue&type=script&lang=js"
import style0 from "./InfoBallon.vue?vue&type=style&index=0&id=90fb0696&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports